import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

export default function SoftwareSkill() {
  const skills = skillsSection.softwareSkills;
  const rowLeft = [...skills, ...skills];
  const rowRight = [...skills.slice().reverse(), ...skills.slice().reverse()];

  return (
    <div className="skills-marquee-wrap">
      <div className="skills-marquee skills-marquee-left">
        <ul className="dev-icons marquee-track">
          {rowLeft.map((skill, i) => (
            <li
              key={`l-${skill.skillName}-${i}`}
              className={`software-skill-inline skill-tone-${i % 5}`}
            >
              <i className={skill.fontAwesomeClassname}></i>
              <p>{skill.skillName}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="skills-marquee skills-marquee-right">
        <ul className="dev-icons marquee-track">
          {rowRight.map((skill, i) => (
            <li
              key={`r-${skill.skillName}-${i}`}
              className={`software-skill-inline skill-tone-${(i + 2) % 5}`}
            >
              <i className={skill.fontAwesomeClassname}></i>
              <p>{skill.skillName}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
